import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const { defineMultiStyleConfig: t, definePartsStyle: o } = e([
  "container",
  "label",
  "badge"
]), i = o({
  container: { display: "inline-flex" },
  label: {
    fontSize: "2xl",
    fontWeight: "normal",
    fontFamily: "body",
    lineHeight: "24px",
    color: "gray.800"
  },
  badge: {
    fontFamily: "body",
    fontSize: "10px",
    fontWeight: "bold",
    lineHeight: "16px",
    textAlign: "center",
    borderTopLeftRadius: "36px",
    borderTopRightRadius: "none",
    borderBottomRightRadius: "36px",
    borderBottomLeftRadius: "none",
    paddingY: "px",
    paddingX: 1
  }
}), l = t({
  baseStyle: i
});
export {
  l as default
};
